import { useAuthContext } from '../contexts/auth';
import { RCS_CAMPAIGN_ENABLED } from '../constants';

/**
 * Determines if RCS-related UI should be visible based on user profile and feature flags.
 * @returns {boolean} `true` if RCS features should be visible, otherwise `false`.
 */
export const useRcsVisibility = (): boolean => {
  const { profile } = useAuthContext();
  return !!profile?.rcsVisible && RCS_CAMPAIGN_ENABLED;
};
